import {NgModule, ErrorHandler} from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import {HttpModule} from '@angular/http';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {IonicStorageModule} from "@ionic/storage";
import {IonicApp, IonicModule} from 'ionic-angular';
import {AutoCompleteModule} from 'ionic2-auto-complete';
import {MomentModule} from "angular2-moment";
import {DatePickerModule} from 'ion-datepicker';
import 'intl';
import 'intl/locale-data/jsonp/it';

import {ConfigService, GetNewsService, KeywordsService, NewsService, SentryErrorHandler, 
  SharedService, SocialService, StorageService, TwitterUsers } from '../providers';
import {HighlightPipe} from "../pipes/highlight";

import {MyApp} from './app.component';
import {LoginPage} from "../pages/login/login";
import {FeedPage} from "../pages/feed/feed";
import {MenuProvider} from "../providers/menu";
import {LoaderPage} from "../pages/loader/loader";
import {NewsDetailPage} from "../pages/news-detail/news-detail";
import {KeywordsAddPage} from "../pages/keywords-add/keywords-add";
import {KeywordsEditPage} from "../pages/keywords-edit/keywords-edit";
import {KeywordsListPage} from "../pages/keywords-list/keywords-list";
import {SettingsPage} from "../pages/settings/settings";
import {Tweets} from "../pages/tweets/tweets";
//import {TweetsFollowings} from "../pages/tweets-followings/tweets-followings";
//import {TweetsKeywords} from "../pages/tweets-keywords/tweets-keywords";
import {TwitterLogout} from "../pages/twitter-logout/twitter-logout";
import {TwitterLogin} from "../pages/twitter-login/twitter-login";
import {TwitterSettings} from "../pages/twitter-settings/twitter-settings";
import {TwitterSettingsKeywords} from "../pages/twitter-settings-keywords/twitter-settings-keywords";
import {TwitterSettingsFollowings} from "../pages/twitter-settings-followings/twitter-settings-followings";
import {TwitterKeywordForm} from "../pages/twitter-keyword-form/twitter-keyword-form";

@NgModule({
  declarations: [
    MyApp,
    LoginPage,
    FeedPage,
    LoaderPage,
    NewsDetailPage,
    HighlightPipe,
    KeywordsAddPage,
    KeywordsEditPage,
    KeywordsListPage,
    SettingsPage,
    Tweets,
    //TweetsFollowings,
    //TweetsKeywords,
    TwitterLogin,
    TwitterLogout,
    TwitterSettings,
    TwitterSettingsKeywords,
    TwitterSettingsFollowings,
    TwitterKeywordForm
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    HttpClientModule,
    HttpModule,
    IonicModule.forRoot(MyApp),
    DatePickerModule,
    IonicStorageModule.forRoot({
      name: '__mydb'
    }),
    AutoCompleteModule,
    MomentModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    LoginPage,
    FeedPage,
    LoaderPage,
    NewsDetailPage,
    KeywordsAddPage,
    KeywordsEditPage,
    KeywordsListPage,
    SettingsPage,
    Tweets,
    //TweetsFollowings,
    //TweetsKeywords,
    TwitterLogin,
    TwitterLogout,
    TwitterSettings,
    TwitterSettingsKeywords,
    TwitterSettingsFollowings,
    TwitterKeywordForm
  ],
  providers: [
    // {provide: ErrorHandler, useClass: IonicErrorHandler},
    {provide: ErrorHandler, useClass: SentryErrorHandler},
    StorageService,
    GetNewsService,
    MenuProvider,
    NewsService,
    KeywordsService,
    SharedService,
    SocialService,
    TwitterUsers,
    ConfigService]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts